import * as Yup from "yup";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";

const allowedTypes = Object.values(RequirementType);

export const requirementDefinitionDefaultValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  type: Yup.string().oneOf(allowedTypes).required("Type is required"),
  instructions: Yup.mixed().when("type", {
    is(type: RequirementType) {
      return [
        RequirementType.BackgroundCheck,
        RequirementType.SharedFile,
        RequirementType.IdentityVerification
      ].includes(type);
    },
    then: Yup.string(),
    otherwise: Yup.mixed().notRequired()
  }),
  description: Yup.string()
});
